import { AppState, PersistentState } from '@mode/legacy/types-app-state';
import { ReducerTree } from '@mode/legacy/util-domain';
import { Actions } from '../actions';
import { initialPersistentReportFilterState, PersistentReportFilterReducer } from './persistent/report-filter.reducers';
import { initialPersistentReportState, PersistentReportReducer } from './persistent/report.reducers';

export const initialPersistentState: PersistentState = {
  reports: initialPersistentReportState,
  reportFilters: initialPersistentReportFilterState,
};

export const PersistentReducer: ReducerTree<AppState, PersistentState, Actions> = {
  reports: PersistentReportReducer,
  reportFilters: PersistentReportFilterReducer,
};
